import React from 'react';
import { Helmet } from 'react-helmet-async';
const CancellationPage = () => {
  return <div className="bg-white" data-id="element-1081" data-mp="1a4tj6xllki5t">
      <Helmet data-id="element-1082" data-mp="1a5v3ztsf0j0q">
        <title data-id="element-1083" data-mp="1a64mkwb4rnwe">
          Driving Lesson Policies Northampton | Cancellations, Health & Safety
        </title>
        <meta name="description" content="Read Northampton Driving School's policies on bookings, cancellations, health, and safety. Clear, fair, and transparent for every pupil." data-id="element-1084" data-mp="1ozr9lkx6qxk9" />
        <meta name="keywords" content="driving lesson cancellation policy, Northampton driving school refunds, driving lesson booking terms, DVSA cancellation policy Northampton, driving test refund terms, health and safety policy" data-id="element-1085" data-mp="1y05x8qxmgoqx" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1086" data-mp="22tqv8iz7tiq4">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1087" data-mp="2gsi8622ccyco">
          Cancellation, Health & Safety Policy
        </h1>
        <p className="mb-6" data-id="element-1088" data-mp="2cszof9m9atbf">
          At <span className="text-burgundy-600" data-id="element-1089" data-mp="2cpllo09oki3g">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1090" data-mp="1xrezo8g763db">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1091" data-mp="21qnsnb3exx7t">S</span>chool, we understand that
          circumstances can change. However, to maintain a fair and efficient
          service for all our students, we have implemented the following
          cancellation, health, and safety policy:
        </p>
        <section className="mb-8" data-id="element-1092" data-mp="2gp83dcynahbr">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1093" data-mp="2go6osyif7cpa">
            Cancellation Notice Requirements
          </h2>
          <p className="mb-4" data-id="element-1094" data-mp="2knxdmwodzir6">
            Northampton Driving School requires 48 hours' notice to cancel or
            reschedule any lesson. This applies to all payments — card, cash, or
            advance online payment. Lessons cancelled with less than 48 hours'
            notice may be charged in full.
          </p>
        </section>
        <section className="mb-8" data-id="element-1095" data-mp="34dhfto9yxsq8">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1096" data-mp="34eitm0idctbn">
            Standard Lessons
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1097" data-mp="2eo0wiqydx4lc">
            <li data-id="element-1098" data-mp="29s3mf2dpsuh0">
              <strong data-id="element-1099" data-mp="29slpoiyso8yf">48+ Hours Notice:</strong> No charge will be applied if
              you cancel or reschedule with at least 48 hours' notice.
            </li>
            <li data-id="element-1100" data-mp="2joyfv6v4s4of">
              <strong data-id="element-1101" data-mp="2jogb1lueki4w">24-48 Hours Notice:</strong> 50% of the lesson fee will be
              charged if you cancel or reschedule with between 24 and 48 hours'
              notice.
            </li>
            <li data-id="element-1102" data-mp="2sgqmt7ky4vo9">
              <strong data-id="element-1103" data-mp="2sh0hv9kult0t">Less than 24 Hours Notice:</strong> The full lesson fee
              will be charged if you cancel or reschedule with less than 24
              hours' notice.
            </li>
            <li data-id="element-1104" data-mp="32g97xrclenhw">
              <strong data-id="element-1105" data-mp="32dmw3fio5ltv">No Show:</strong> If you fail to attend a scheduled lesson
              without any prior notice, the full lesson fee will be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1106" data-mp="1841eyjju0gor">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1107" data-mp="3joiinan2ptob">
            Health and Safety Policy
          </h2>
          <p className="mb-4" data-id="element-1108" data-mp="3omtpdci2no2b">
            To protect other pupils and the instructor, please do not attend if
            you are unwell. If you attend with obvious cold/flu/cough symptoms
            you may be asked to leave and the lesson may still be chargeable.
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1109" data-mp="30yarlqwnetoh">
            <li data-id="element-1110" data-mp="310x0btv9zf8a">
              If you or anyone in your household is unwell, please cancel your
              lesson to avoid spreading illness.
            </li>
            <li data-id="element-1111" data-mp="2r1o75388i4mz">
              Pupils who arrive with cough/cold symptoms may be asked to end the
              lesson to protect other learners.
            </li>
            <li data-id="element-1112" data-mp="p8hxj4f7rmlk">
              Please maintain good personal hygiene so the car remains a
              pleasant, professional learning environment.
            </li>
            <li data-id="element-1113" data-mp="u606gut8e1tk">
              The instructor reserves the right to end a lesson early if health
              and safety concerns arise.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1114" data-mp="2lcxpmb0h2uih">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1115" data-mp="2haav22cf2vhl">
            Intensive Courses
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1116" data-mp="2cbzllsq1amzw">
            <li data-id="element-1117" data-mp="2cdkeldwp9xvn">
              <strong data-id="element-1118" data-mp="27cd95li15as5">7+ Days Notice:</strong> Full refund less a £50
              administration fee.
            </li>
            <li data-id="element-1119" data-mp="22l4w8fhhr7a8">
              <strong data-id="element-1120" data-mp="22klqry912bd3">3-7 Days Notice:</strong> 50% of the course fee will be
              retained.
            </li>
            <li data-id="element-1121" data-mp="1xn3f403mli1e">
              <strong data-id="element-1122" data-mp="1xkh8q3sh18kr">Less than 3 Days Notice:</strong> No refund will be
              provided.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1123" data-mp="1omeyqyqrf5lc">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1124" data-mp="1olcbr1wk5nap">
            Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1125" data-mp="1jnkj25o39x5g">
            <li data-id="element-1126" data-mp="3vaxiqfjmboqt">
              <strong data-id="element-1127" data-mp="3v9cmmlhnnxqu">Test Day Cancellation:</strong> If you cancel the use of
              the instructor's car for your test with less than 3 working days'
              notice, the full fee will still be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1128" data-mp="d49cungquxk3">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1129" data-mp="d382ymbgsh3y">
            Driving Test Cancellation Policy
          </h2>
          <p className="mb-4" data-id="element-1130" data-mp="3chjuetaeugk6">
            Northampton Driving School is not responsible for refunds if the
            DVSA cancels, postpones, or changes a pupil's test date. Pupils book
            and manage their own DVSA driving test appointments and must contact
            the DVSA directly to rebook or amend them.
          </p>
        </section>
        <section className="mb-8" data-id="element-1131" data-mp="2ttyax96vlw2k">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1132" data-mp="2tswsgjnj67at">
            Exceptional Circumstances
          </h2>
          <p data-id="element-1133" data-mp="2xse09jqfjgj5">
            We understand that exceptional circumstances such as illness,
            emergencies, or bereavement may arise. In such cases, please contact
            us as soon as possible, and we will do our best to accommodate your
            situation. Supporting documentation may be requested.
          </p>
        </section>
        <section className="mb-8" data-id="element-1134" data-mp="9s1h2yvgr7n0">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1135" data-mp="9t3481pr7kl3">
            Instructor Cancellations
          </h2>
          <p className="mb-4" data-id="element-1136" data-mp="3d7p2too8aghr">
            In the rare event that your instructor needs to cancel a lesson, we
            will:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1137" data-mp="3r8jeqhahizl6">
            <li data-id="element-1138" data-mp="3n5wim46s6si6">Notify you as soon as possible</li>
            <li data-id="element-1139" data-mp="3n4bkk4l9crfk">Offer an alternative date and time</li>
            <li data-id="element-1140" data-mp="16gzcmjb1f9l8">
              If no suitable alternative can be found, provide a full refund for
              that lesson
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1141" data-mp="12hqmdof7htuf">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1142" data-mp="19yncn167xc4u">
            Weather Conditions
          </h2>
          <p className="mb-4" data-id="element-1143" data-mp="1ezb1phavziwf">
            For safety reasons, lessons may need to be cancelled due to severe
            weather conditions (e.g., heavy snow, ice, fog, or flooding). In
            such cases:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1144" data-mp="150ls0bt594r9">
            <li data-id="element-1145" data-mp="1sp4to8houjad">
              The instructor will make the final decision based on safety
              considerations
            </li>
            <li data-id="element-1146" data-mp="1xo7ypsxo4pic">No cancellation fee will be charged</li>
            <li data-id="element-1147" data-mp="1j0eh62p0vcx4">
              We will work with you to reschedule the lesson as soon as possible
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1148" data-mp="1nxd7091nkxpi">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1149" data-mp="2boiqcy6sy84k">
            Payment and Refunds
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1150" data-mp="2gfsdns4vozda">
            <li data-id="element-1151" data-mp="2ghbtjhmmh8ej">
              Refunds for eligible cancellations will be processed within 10
              working days
            </li>
            <li data-id="element-1152" data-mp="blr9zl3hqazz">
              Refunds will be made using the same payment method used for the
              original transaction
            </li>
            <li data-id="element-1153" data-mp="7l7fyqe7rni2">
              Block booking discounts may be adjusted if cancellations reduce
              the number of lessons below the threshold for the discount
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1154" data-mp="z9r8x8ayh7pn">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1155" data-mp="v9qmp1hm7s81">
            Contact Us
          </h2>
          <p className="mb-4" data-id="element-1156" data-mp="qae08hunon5z">
            If you need to cancel or reschedule a lesson, please contact us as
            soon as possible:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1157" data-mp="le6qsf31wtja">
            <li data-id="element-1158" data-mp="3b2fqsqaixn3a">Phone: 07481 300 600</li>
            <li data-id="element-1159" data-mp="3azbh5deahz58">Email: info@northamptondrivingschool.co.uk</li>
          </ul>
        </section>
        <p data-id="element-1160" data-mp="364e9oawnrxug">
          This cancellation policy is effective from January 1, 2023, and may be
          subject to change. Any changes will be communicated to existing
          students and updated on our website.
        </p>
      </div>
    </div>;
};
export default CancellationPage;